'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$80() {
  this.bHR = null;
  this.bHS = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$80 as $c_Lpresto_TwoFactorAuthView$$anon$80 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$80.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$80;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$80() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$80 as $h_Lpresto_TwoFactorAuthView$$anon$80 };
$h_Lpresto_TwoFactorAuthView$$anon$80.prototype = $p;
$p.P = (function() {
  if ((!this.bHS)) {
    this.bHR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bHS = true;
  }
  return this.bHR;
});
var $d_Lpresto_TwoFactorAuthView$$anon$80 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$80, "presto.TwoFactorAuthView$$anon$80", ({
  Tk: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$80 as $d_Lpresto_TwoFactorAuthView$$anon$80 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$80.js.map
